var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-traceability-map"},[(_vm.batch)?_c('traceability-maps',{attrs:{"current-status":_vm.batch.currentStatus,"o-s-alvaro":_vm.batch.codeOS || _vm.batch.barcode,"locations":_vm.mapLocations,"laboratory":{ name: _vm.batch.laboratory.name, address: _vm.batch.laboratory.address },"nto":{
      name: `NTO ${_vm.ntoName}`,
      address: _vm.batch.nto.address,
    },"current-location":{
      address: _vm.batch.lotLocation.address,
      position: {
        lat: Number(_vm.batch.lotLocation.latitude),
        lng: Number(_vm.batch.lotLocation.longitude),
      },
    },"button-label":'VER AMOSTRAS',"button-action":() => _vm.goToAmostras(),"update-map-in-minutes":_vm.updatedAtInMinutes}}):_c('div',[_vm._v("Selecione um lote")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }